import React from "react";
import "./style.scss";
import ".";
import Group1 from "./Group1.png";
import Group2 from "./Group2.png";
import Group3 from "./Group3.png";
import ServicesIllustration from "./services-illustration.svg";
import { translateString } from "../../../helpers/translator";

const HomeDefault = ({language}) => {
  return (
    <div className="services_page" id="services">
      <img
        src={ServicesIllustration}
        alt=""
        className="services-page__corner-illustration"
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="services_page__title">
              <div className="services_page__title__div">{translateString("HOME.SERVICES.ourServices", language)}</div>
              <h2>{translateString("HOME.SERVICES.header_1", language)}</h2>
              <p>
                {translateString("HOME.SERVICES.p_1", language)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-3 container__leftside">
            <div className="container__leftside__box">
              <div className="container__leftside__box__title">
              {translateString("HOME.SERVICES.servicesOverview", language)}
              </div>
              <div className="container__leftside__box__list">
                <ul>
                  <li>{translateString("HOME.SERVICES.firstList_1", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_2", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_3", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_4", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_5", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_6", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_7", language)}</li>
                  <li>{translateString("HOME.SERVICES.firstList_8", language)}</li>
                </ul>
              </div>
            </div>
            <div className="container__leftside__box">
              <div className="container__leftside__box__title">{translateString("HOME.SERVICES.techStack", language)}</div>
              <div className="container__leftside__box__list">
                <ul>
                  <li>REACT</li>
                  <li>NODE</li>
                  <li>JAVASCRIPT / TYPESCRIPT</li>
                  <li>SQL</li>
                  <li>PYTHON</li>
                  <li style={{ marginBottom: "48px" }}>PHP</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-3"> </div>
          <div className="col-lg-6">
            <div className="container__rightside">
              <div className="container__rightside__box" id="box1">
                <div className="container__rightside__box__photo">
                  <img src={Group1}></img>
                </div>
                <div className="container__rightside__box__upper">
                  <h4>{translateString("HOME.SERVICES.header_2", language)}</h4>
                  <p>
                    {translateString("HOME.SERVICES.p_2", language)}
                  </p>
                </div>
                <div className="container__rightside__box__lower">
                  <div className="container__rightside__box__lower__title">
                  {translateString("HOME.SERVICES.features1", language)}
                  </div>
                  <ul>
                    <li>{translateString("HOME.SERVICES.features1List_1", language)}</li>
                    <li>{translateString("HOME.SERVICES.features1List_2", language)}</li>
                    <li>{translateString("HOME.SERVICES.features1List_3", language)}</li>
                  </ul>
                </div>
              </div>
              <div className="container__rightside__box" id="box2">
                <div className="container__rightside__box__photo">
                  <img src={Group2}></img>
                </div>
                <div className="container__rightside__box__upper">
                  <h4>{translateString("HOME.SERVICES.header_3", language)}</h4>
                  <p>
                  {translateString("HOME.SERVICES.p_3", language)}
                  </p>
                </div>
                <div className="container__rightside__box__lower">
                  <div className="container__rightside__box__lower__title">
                  {translateString("HOME.SERVICES.features1", language)}
                  </div>
                  <ul>
                    <li>{translateString("HOME.SERVICES.features2List_1", language)}</li>
                    <li>{translateString("HOME.SERVICES.features2List_2", language)}</li>
                    <li>{translateString("HOME.SERVICES.features2List_3", language)}</li>
                    <li>{translateString("HOME.SERVICES.features2List_4", language)}</li>
                  </ul>
                </div>
              </div>
              <div className="container__rightside__box" id="box3">
                <div className="container__rightside__box__photo">
                  <img src={Group3}></img>
                </div>
                <div className="container__rightside__box__upper">
                  <h4>{translateString("HOME.SERVICES.header_4", language)}</h4>
                  <p>
                  {translateString("HOME.SERVICES.p_4", language)}
                  </p>
                </div>
                <div className="container__rightside__box__lower">
                  <div className="container__rightside__box__lower__title">
                  {translateString("HOME.SERVICES.features1", language)}
                  </div>
                  <ul>
                    <li>{translateString("HOME.SERVICES.features3List_1", language)}</li>
                    <li>{translateString("HOME.SERVICES.features3List_2", language)}</li>
                    <li>{translateString("HOME.SERVICES.features3List_3", language)}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default HomeDefault; // Default export